/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Logger, LogService } from '@epg/angular-base-lib';
import {
  ImageExtendedData,
  TaskDataImage,
  TaskDataImageExtended,
  TaskDataImagePng,
  TaskDataString,
  TaskDatumModel,
  TaskDatumType
} from '../../../../../../../models/task.model';

@Component({
  selector: 'app-extended-image-item',
  templateUrl: './extended-image-item.component.html',
  styleUrls: ['./extended-image-item.component.scss'],
  standalone: false
})
export class ExtendedImageItemComponent implements OnInit {
  @Input() extendedImageItem: ImageExtendedData = new ImageExtendedData(
    new TaskDataImagePng(''),
    new TaskDataString('')
  );
  imagePath: SafeResourceUrl = '';
  description: string = '';
  TaskDatumType = TaskDatumType;

  private log: Logger;
  constructor(
    private _sanitizer: DomSanitizer,
    private logService: LogService
  ) {
    this.log = logService.getLogger(this);
  }

  ngOnInit(): void {
    this.log.debug(this.extendedImageItem);
    this.description = this.extendedImageItem.description?.value ?? '';
    if (this.extendedImageItem.image.type === TaskDatumType.IMAGE_URL) {
      return;
    }
    let mimeType;
    switch (this.extendedImageItem.image.type) {
      case TaskDatumType.IMAGE_PNG:
        mimeType = 'image/png';
        break;
      case TaskDatumType.IMAGE_JPEG:
      default:
        mimeType = 'image/jpeg';
        break;
    }

    this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl(
      'data:' + mimeType + ';base64,' + this.extendedImageItem.image.value
    );
  }
}
